import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4633" />
      <ArchitectureDiagram data-id="element-4634" />
      <HowItWorksConnections mode="how" data-id="element-4635" />
      <LivesInSlack data-id="element-4636" />
      <ComputerUse data-id="element-4637" />
      <CapabilityGrid data-id="element-4638" />
      <NarrativeSection data-id="element-4639" />
      <ToolComparison data-id="element-4640" />
      <WallOfLove data-id="element-4641" />
      <PricingSection data-id="element-4642" />
      <ClosingCTA data-id="element-4643" />
    </>;
}